import { useMemo, useState } from "react";
import { freshNews } from "@/mocks/gossip";

const catColor: Record<string, string> = {
  影视: "bg-primary-500/10 text-primary-700",
  综艺: "bg-accent-500/10 text-accent-700",
  音乐: "bg-secondary-500/15 text-secondary-800",
  生活: "bg-primary-500/10 text-primary-700",
  演出: "bg-accent-500/10 text-accent-700",
  人物: "bg-secondary-500/15 text-secondary-800",
};

export default function FreshNews() {
  const cats = useMemo(
    () => ["全部", ...Array.from(new Set(freshNews.map((n) => n.category)))],
    []
  );
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? freshNews : freshNews.filter((n) => n.category === active);

  return (
    <section id="fresh" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex flex-col justify-between gap-4 lg:flex-row lg:items-end">
          <div>
            <p className="text-xs font-medium uppercase tracking-widest text-accent-600">Live Feed</p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              新鲜速递 · 今日滚动
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              正在发酵的近期新瓜按时间倒序实时收录，追热点不再怕错过进度。
            </p>
          </div>
        </div>

        <div className="mb-6 flex flex-wrap items-center gap-2" role="tablist" aria-label="速递筛选">
          {cats.map((c) => (
            <button
              key={c}
              type="button"
              role="tab"
              aria-selected={active === c}
              onClick={() => setActive(c)}
              className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                active === c
                  ? "bg-foreground-950 font-medium text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-600 hover:bg-background-100"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="relative border-l-2 border-background-200 pl-6 md:pl-10">
          <span
            className="absolute -left-[7px] top-1 h-3 w-3 rounded-full bg-primary-500"
            aria-hidden="true"
          ></span>
          <ol className="flex flex-col gap-5">
            {list.map((news) => {
              const color = catColor[news.category] || "bg-secondary-500/15 text-secondary-800";
              return (
                <li key={news.id} className="relative">
                  <span
                    className="absolute top-3 -left-[41px] hidden h-3 w-3 rounded-full border-2 border-background-50 bg-primary-500 md:-left-[57px] md:block"
                    aria-hidden="true"
                  ></span>
                  <article className="rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:bg-background-100/60 md:p-5">
                    <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                      <div className="flex flex-wrap items-center gap-2.5">
                        <span className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-foreground-500">
                          <i className="ri-time-line" aria-hidden="true"></i>
                          {news.time}
                        </span>
                        <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${color}`}>
                          {news.category}
                        </span>
                        <h3 className="text-sm font-bold text-foreground-950 md:text-base">
                          {news.title}
                        </h3>
                      </div>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:pl-8">
                      {news.brief}
                    </p>
                  </article>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}